import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the ShortenPipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'shorten',
})
export class ShortenPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    let limit = args.length > 0 ? parseInt(args[0], 10) : 250;
    let trail = args.length > 1 ? args[1] : '...';
    return (value) ? (value.length > limit ? value.substring(0, limit) + trail : value) : null;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/shorten/shorten.ts